import { FC } from "react";
import { SelectFormField } from "@blanket/components/formFields/FormFields";
import { lawyerOrLawFirmSelectOptions } from "../../eligibility/participantEligibilityUi";

type LawyerOrLawFirmSelectFieldProps = {
  namePrefix: string;
  idPrefix: string;
  label: string;
};

export const LawyerOrLawFirmSelectField: FC<
  LawyerOrLawFirmSelectFieldProps
> = ({ namePrefix, idPrefix, label }) => (
  <SelectFormField
    name={`${namePrefix}.isLawyerOrLawFirm`}
    label={label}
    id={`${idPrefix}-is-lawyer-or-law-firm`}
    isRequired
    options={lawyerOrLawFirmSelectOptions}
  />
);
